import NavBar from 'components/assets/edit/AssetsEditNavBar';
import Wrapper from 'components/assets/edit/AssetsEditWrapper';

export default { NavBar, Wrapper };



// WEBPACK FOOTER //
// src/components/assets/edit/index.js